// extracted by mini-css-extract-plugin
export var blurWrap = "HeaderMain-module--blurWrap--0deba";
export var notStick = "HeaderMain-module--notStick--56c56";
export var referralBanner = "HeaderMain-module--referralBanner--1ff36";
export var root = "HeaderMain-module--root--3b0c6";